import axios from 'axios';
import { apiClient } from './apiClient';
import { ApiError } from '../error/error';




//Λιστα όλων των οντοτητων
export const getUnitsDropDown = async () => {
  try {
    const response = await apiClient.get(`api/admin/drops/units`);

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to get units', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
  
};


//Λιστα όλων των οντοτητων
export const getPositionsDropDown = async () => {
  try {
    const response = await apiClient.get(`api/admin/drops/positions`);

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to get position', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
  
};


//Λιστα οντοτητων DropDown
export const getOntotisDropDown = async () => {
  try {
    const response = await apiClient.get(`api/admin/drops/ontotis`);
  
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to get title ontotis', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
  
};